import React from 'react'
import HubspotForm from 'react-hubspot-form'
import { CircularProgress, Paper, Typography } from '@mui/material'
import PageDescriptionComponent from '../HelpfulGuides/PageDescriptionComponent'

interface IHubspotFormProps {
  classes?: any
}
interface IHubspotFormState {
  hubspotReady: boolean
}

class HubspotLoanApplicationForm extends React.Component<
  IHubspotFormProps,
  IHubspotFormState
> {
  placeholder: any
  constructor(props: IHubspotFormProps) {
    super(props)
    this.state = {
      hubspotReady: false,
    }
  }

  render() {
    return (
      <>
        <PageDescriptionComponent
          textContent={
            <>
              <Typography variant={'h6'} gutterBottom={true} align={'center'}>
                <b>Loan application form</b>
              </Typography>
              <Typography
                variant={'body2'}
                gutterBottom={true}
                align={'center'}
              >
                We have partners that can help you get a loan to pay for your
                courses. <br /> However it is important to know that the loan is
                in no way guaranteed.
                <br />
                We will reach out to you with a loan application form to check
                your eligibility.
              </Typography>
            </>
          }
        />

        <Paper style={{ padding: '50px 20px' }}>
          <HubspotForm
            portalId="5826839"
            formId="c4bc1c6a-5d34-4f6b-ba35-3b888166f76d"
            onSubmit={() => console.log('Submit!')}
            onReady={(_form: any) => console.log('Form ready!')}
            loading={
              <div style={{ width: '100%', textAlign: 'center' }}>
                <CircularProgress
                  color="primary"
                  style={{ margin: 'auto' }}
                  size={20}
                />
              </div>
            }
          />
        </Paper>
      </>
    )
  }
}

export default HubspotLoanApplicationForm
